// Tracking Events Constants for Search
export const SEARCH_TRACKING_EVENTS = {
  SEARCH_SUBMIT: 'Search Submit',
  SEARCH_FOCUS: 'Search Focus',
  SEARCH_UNFOCUS: 'Search Unfocus',
  RECENT_SEARCH_CLICK: 'Recent Search Click',
  CLEAR_RECENT_SEARCHES: 'Clear Recent Searches',
  RESULT_INTERACTION: 'Result Interaction',
  TAB_CHANGE: 'Tab Change',
  SEARCH_BAR_VISIBILITY: 'Search Bar Visibility'
}

export const SEARCH_ACTIONS = {
  SUBMIT: 'submit',
  FOCUS: 'focus',
  UNFOCUS: 'unfocus',
  CLICK_RECENT: 'click_recent',
  CLEAR_RECENT: 'clear_recent',
  RESULT_CLICK: 'result_click',
  TAB_CHANGE: 'tab_change',
  SHOW_BAR: 'show_bar',
  HIDE_BAR: 'hide_bar'
}

export const SEARCH_PLATFORMS = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile'
}
